import React, { useEffect, useState } from "react";
import _ from "lodash";
import { Checkbox, TextField, Slider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  sliderContainer: {
    display: `flex`,
    flexDirection: `column`,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    alignItems: `center`,
    "& > *": {
      marginBottom: theme.spacing(1)
    }
  },
  sliderSlider: {
    "&.MuiSlider-vertical": {
      height: `200px`,
      maxHeight: `35vh`
    }
  },
  sliderTextField: {
    width: `50px`,
    marginRight: 0,
    "& .MuiOutlinedInput-input": {
      padding: theme.spacing(1)
    },
    "& .MuiInputLabel-root": {
      transform: `translate(6px, 10px)`
    },
    "& .MuiInputLabel-root.MuiInputLabel-shrink": {
      transform: `translate(14px, -4px) scale(0.75)`
    },
    display: `flex`,
    fledDirection: `column`,
    justifyContent: `center`
  }
}));

const numbers = `0123456789`;
const minModifier = -50;
const maxModifier = 50;

const DifficultySlider = ({
  disabled,
  DC,
  mod,
  onToggle,
  onDCChange,
  onModChange
}) => {
  const classes = useStyles();
  const [displayedDC, setDisplayedDC] = useState(DC);

  useEffect(() => {
    setDisplayedDC(DC);
  }, [DC]);

  const onDCKeyPress = evt => {
    if (!_.includes(numbers, evt.key)) evt.preventDefault();
  };

  const onDCTextChange = evt => {
    setDisplayedDC(evt.target.value);
  };

  const onDCBlur = evt => {
    _.chain(displayedDC)
      .toInteger()
      .thru(val => Math.max(val, mod + 1))
      .thru(val => Math.min(val, mod + 20))
      .tap(val => setDisplayedDC(val))
      .thru(val => onDCChange(evt, val))
      .commit();
  };

  const onModKeyPress = evt => {
    if (`-` === evt.key) {
      onModChange(-mod);
      evt.preventDefault();
    }
  };

  const onModTextChange = evt => {
    _.chain(evt.target.value)
      .toInteger()
      .thru(val => Math.max(val, minModifier))
      .thru(val => Math.min(val, maxModifier))
      .thru(val => onModChange(val))
      .commit();
  };

  return (
    <div className={classes.sliderContainer}>
      <Checkbox color="primary" checked={!disabled} onChange={onToggle} />
      <TextField
        variant="outlined"
        label="DC"
        value={displayedDC}
        className={classes.sliderTextField}
        disabled={disabled}
        onKeyPress={onDCKeyPress}
        onChange={onDCTextChange}
        onBlur={onDCBlur}
      />
      <Slider
        orientation="vertical"
        valueLabelDisplay="auto"
        getAriaValueText={() => `${DC} DC`}
        aria-label={`DC`}
        step={1}
        min={mod + 1}
        max={mod + 20}
        value={DC}
        className={classes.sliderSlider}
        disabled={disabled}
        onChange={onDCChange}
      />
      <TextField
        variant="outlined"
        label="Mod"
        value={_.toString(mod)}
        className={classes.sliderTextField}
        disabled={disabled}
        onKeyPress={onModKeyPress}
        onChange={onModTextChange}
      />
    </div>
  );
};

export default DifficultySlider;
